import React from 'react';
import {
  Button,
  IconButton,
  Link,
  Pressable,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleScrollView,
  Surface,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { BlurView } from 'expo-blur';
import * as Linking from 'expo-linking';
import * as WebBrowser from 'expo-web-browser';
import { ActivityIndicator, Image, Modal, Text, View } from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as DefaultApi from '../apis/DefaultApi.js';
import * as StripeApi from '../apis/StripeApi.js';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import checkExpires from '../global-functions/checkExpires';
import resetGlobals from '../global-functions/resetGlobals';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { screen_from: 'login' };

const PaymentPlanSelectionScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedPackage, setSelectedPackage] = React.useState({});
  const [selectedType, setSelectedType] = React.useState('monthly');
  const [visibleSelect, setVisibleSelect] = React.useState(false);
  const [visibleSelectDemo, setVisibleSelectDemo] = React.useState(false);
  const convertInt = formattedCost => {
    return Math.round(parseFloat(formattedCost) * 100);
  };

  const formatData = (data, subscriptionId) => {
    return data
      .map(item => {
        const [name, type] = item.name.split(' - ');

        let costString = item.cost.toString();
        // let formattedCost = costString.length > 2
        //   ? costString.slice(0, -2) + '.' + costString.slice(-2)
        //   : '0.' + costString.padStart(2, '0');

        let formattedCost =
          costString.length > 2
            ? costString.slice(0, -2) + '.' + costString.slice(-2)
            : '0';

        return {
          ...item,
          name,
          type: type ? type.toLowerCase() : null,
          cost: formattedCost,
        };
      })
      .filter((item, index) => {
        // Eğer subscriptionId null veya boşsa id'si 1 olan objeyi göster
        if (!subscriptionId && item.id === 1) {
          return true;
        }

        // Eğer subscriptionId varsa id'si 1 olan objeyi gizle
        if (subscriptionId && item.id === 1) {
          return false;
        }

        // Diğer filtreleme mantığı devam ediyor
        if (index === 0) return true;
        return selectedType ? item.type === selectedType.toLowerCase() : true;
      });
  };
  const stripeSessionPOST = StripeApi.useSessionPOST();
  const defaultActivateDemoSubscriptionPOST =
    DefaultApi.useActivateDemoSubscriptionPOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <SimpleStyleScrollView
            bounces={true}
            horizontal={false}
            keyboardShouldPersistTaps={'never'}
            nestedScrollEnabled={false}
            showsHorizontalScrollIndicator={true}
            showsVerticalScrollIndicator={true}
            style={StyleSheet.applyWidth(
              {
                maxHeight: {
                  minWidth: Breakpoints.Laptop,
                  value: dimensions.height,
                },
              },
              dimensions.width
            )}
          >
            {/* Logo */}
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
                  justifyContent: {
                    minWidth: Breakpoints.Laptop,
                    value: 'center',
                  },
                },
                dimensions.width
              )}
            >
              {/* Image 2 */}
              <Image
                {...GlobalStyles.ImageStyles(theme)['Image'].props}
                resizeMode={'contain'}
                source={imageSource(Images['logocropped'])}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ImageStyles(theme)['Image'].style,
                    {
                      height: [
                        { minWidth: Breakpoints.Laptop, value: 200 },
                        { minWidth: Breakpoints.Desktop, value: 200 },
                        { minWidth: Breakpoints.BigScreen, value: 250 },
                      ],
                      width: [
                        { minWidth: Breakpoints.Laptop, value: 200 },
                        { minWidth: Breakpoints.Desktop, value: 200 },
                        { minWidth: Breakpoints.BigScreen, value: 250 },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              />
            </View>

            <View
              style={StyleSheet.applyWidth(
                { marginTop: { minWidth: Breakpoints.Laptop, value: '5%' } },
                dimensions.width
              )}
            >
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.App['Custom White'],
                      },
                      fontFamily: {
                        minWidth: Breakpoints.Laptop,
                        value: 'Inter_400Regular',
                      },
                      fontSize: { minWidth: Breakpoints.Laptop, value: 24 },
                      textAlign: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                    }
                  ),
                  dimensions.width
                )}
              >
                {'Choose Your Plan'}
              </Text>
              {/* Plans */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    backgroundColor: {
                      minWidth: Breakpoints.Laptop,
                      value: palettes.App['Custom White'],
                    },
                    borderRadius: { minWidth: Breakpoints.Laptop, value: 12 },
                    gap: { minWidth: Breakpoints.Laptop, value: 20 },
                    marginTop: { minWidth: Breakpoints.Laptop, value: '5%' },
                    paddingBottom: { minWidth: Breakpoints.Laptop, value: 40 },
                    paddingTop: { minWidth: Breakpoints.Laptop, value: 20 },
                    width: { minWidth: Breakpoints.Laptop, value: '100%' },
                  },
                  dimensions.width
                )}
              >
                {/* Tab View */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      alignSelf: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      borderColor: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.App['Gray Linear Light'],
                      },
                      borderRadius: { minWidth: Breakpoints.Laptop, value: 12 },
                      borderWidth: { minWidth: Breakpoints.Laptop, value: 1 },
                      flexDirection: {
                        minWidth: Breakpoints.Laptop,
                        value: 'row',
                      },
                      gap: { minWidth: Breakpoints.Laptop, value: 4 },
                      padding: { minWidth: Breakpoints.Laptop, value: 4 },
                    },
                    dimensions.width
                  )}
                >
                  <Pressable
                    onPress={() => {
                      try {
                        setSelectedType('monthly');
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                  >
                    <View
                      style={StyleSheet.applyWidth(
                        {
                          backgroundColor: {
                            minWidth: Breakpoints.Laptop,
                            value:
                              selectedType === 'monthly'
                                ? palettes.App['Tab Background']
                                : undefined,
                          },
                          borderColor: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.App['Gray Linear Light'],
                          },
                          borderRadius: {
                            minWidth: Breakpoints.Laptop,
                            value: 6,
                          },
                          borderWidth: [
                            { minWidth: Breakpoints.Laptop, value: 1 },
                            {
                              minWidth: Breakpoints.Laptop,
                              value: selectedType === 'monthly' ? 1 : 0,
                            },
                          ],
                          padding: { minWidth: Breakpoints.Laptop, value: 5 },
                          width: { minWidth: Breakpoints.Laptop, value: 75 },
                        },
                        dimensions.width
                      )}
                    >
                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              fontFamily: {
                                minWidth: Breakpoints.Laptop,
                                value: 'Inter_600SemiBold',
                              },
                              textAlign: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'Monthly'}
                      </Text>
                    </View>
                  </Pressable>

                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.TextStyles(theme)['Text'].style,
                      dimensions.width
                    )}
                  >
                    {'/'}
                  </Text>

                  <Pressable
                    onPress={() => {
                      try {
                        setSelectedType('yearly');
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                  >
                    <View
                      style={StyleSheet.applyWidth(
                        {
                          backgroundColor: {
                            minWidth: Breakpoints.Laptop,
                            value:
                              selectedType === 'yearly'
                                ? palettes.App['Tab Background']
                                : undefined,
                          },
                          borderColor: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.App['Gray Linear Light'],
                          },
                          borderRadius: {
                            minWidth: Breakpoints.Laptop,
                            value: 6,
                          },
                          borderWidth: [
                            { minWidth: Breakpoints.Laptop, value: 1 },
                            {
                              minWidth: Breakpoints.Laptop,
                              value: selectedType === 'yearly' ? 1 : 0,
                            },
                          ],
                          padding: { minWidth: Breakpoints.Laptop, value: 5 },
                          width: { minWidth: Breakpoints.Laptop, value: 75 },
                        },
                        dimensions.width
                      )}
                    >
                      <Text
                        accessible={true}
                        selectable={false}
                        {...GlobalStyles.TextStyles(theme)['Text'].props}
                        style={StyleSheet.applyWidth(
                          StyleSheet.compose(
                            GlobalStyles.TextStyles(theme)['Text'].style,
                            {
                              fontFamily: {
                                minWidth: Breakpoints.Laptop,
                                value: 'Inter_600SemiBold',
                              },
                              textAlign: {
                                minWidth: Breakpoints.Laptop,
                                value: 'center',
                              },
                            }
                          ),
                          dimensions.width
                        )}
                      >
                        {'Yearly'}
                      </Text>
                    </View>
                  </Pressable>
                </View>

                <DefaultApi.FetchSubscriptionPlansGET>
                  {({ loading, error, data, refetchSubscriptionPlans }) => {
                    const fetchData = data?.json;
                    if (loading) {
                      return <ActivityIndicator />;
                    }

                    if (error || data?.status < 200 || data?.status >= 300) {
                      return <ActivityIndicator />;
                    }

                    return (
                      <SimpleStyleFlatList
                        data={formatData(
                          fetchData,
                          Constants['USER_DETAILS']?.subscription_plans_id
                        )}
                        decelerationRate={'normal'}
                        inverted={false}
                        keyExtractor={(listData, index) =>
                          listData?.id ??
                          listData?.uuid ??
                          index?.toString() ??
                          JSON.stringify(listData)
                        }
                        keyboardShouldPersistTaps={'never'}
                        listKey={'5HLfrmUc'}
                        nestedScrollEnabled={false}
                        numColumns={1}
                        onEndReachedThreshold={0.5}
                        pagingEnabled={false}
                        renderItem={({ item, index }) => {
                          const listData = item;
                          return (
                            <>
                              {/* Card View */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignSelf: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    borderColor: {
                                      minWidth: Breakpoints.Laptop,
                                      value: palettes.App['Gray Linear Light'],
                                    },
                                    borderRadius: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                    borderWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    height: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 360,
                                    },
                                    padding: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 10,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Border */}
                                <View
                                  style={StyleSheet.applyWidth(
                                    {
                                      alignItems: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'flex-start',
                                      },
                                      alignSelf: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 'center',
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'center',
                                        },
                                      ],
                                      borderColor: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value:
                                            palettes.App['Gray Linear Light'],
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'rgb(164, 164, 164)',
                                        },
                                      ],
                                      borderRadius: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 12,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 6,
                                        },
                                      ],
                                      borderWidth: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 1,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 5,
                                        },
                                      ],
                                      flex: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 1,
                                      },
                                      gap: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                      ],
                                      justifyContent: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 'space-between',
                                      },
                                      paddingBottom: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 20,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                      paddingLeft: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                      ],
                                      paddingRight: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 40,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 40,
                                        },
                                      ],
                                      paddingTop: [
                                        {
                                          minWidth: Breakpoints.Desktop,
                                          value: 20,
                                        },
                                        {
                                          minWidth: Breakpoints.Laptop,
                                          value: 20,
                                        },
                                      ],
                                    },
                                    dimensions.width
                                  )}
                                >
                                  {/* Text View */}
                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flex: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                        gap: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 4,
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Header 1 */}
                                    <Text
                                      accessible={true}
                                      selectable={false}
                                      {...GlobalStyles.TextStyles(theme)['Text']
                                        .props}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.TextStyles(theme)['Text']
                                            .style,
                                          {
                                            fontFamily: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'Inter_700Bold',
                                            },
                                            fontSize: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 20,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                    >
                                      {listData?.name}
                                    </Text>
                                    {/* Description */}
                                    <>
                                      {listData?.type ? null : (
                                        <Text
                                          accessible={true}
                                          selectable={false}
                                          {...GlobalStyles.TextStyles(theme)[
                                            'Text'
                                          ].props}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.TextStyles(theme)[
                                                'Text'
                                              ].style,
                                              {
                                                fontFamily: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'Inter_400Regular',
                                                },
                                                fontSize: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 16,
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          {'free desktop use'}
                                        </Text>
                                      )}
                                    </>
                                    <View>
                                      {/* Price */}
                                      <>
                                        {!listData?.type ? null : (
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'Inter_700Bold',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 20,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'$'}
                                            {listData?.cost}
                                            {/* Price 2 */}
                                            <>
                                              {!listData?.type ? null : (
                                                <Text
                                                  accessible={true}
                                                  selectable={false}
                                                  {...GlobalStyles.TextStyles(
                                                    theme
                                                  )['Text'].props}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.TextStyles(
                                                        theme
                                                      )['Text'].style,
                                                      {
                                                        fontFamily: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            'Inter_400Regular',
                                                        },
                                                        fontSize: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 16,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {'/'}
                                                  {listData?.type}
                                                </Text>
                                              )}
                                            </>
                                          </Text>
                                        )}
                                      </>
                                      {/* Price 2 */}
                                      <>
                                        {!listData?.type ? null : (
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  alignSelf: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'Inter_400Regular',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 14,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'per user'}
                                          </Text>
                                        )}
                                      </>
                                    </View>
                                  </View>

                                  <View
                                    style={StyleSheet.applyWidth(
                                      {
                                        flex: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 2.5,
                                        },
                                        justifyContent: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'space-between',
                                        },
                                      },
                                      dimensions.width
                                    )}
                                  >
                                    {/* Description */}
                                    <View>
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Text'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          StyleSheet.compose(
                                            GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].style,
                                            {
                                              fontFamily: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'Inter_400Regular',
                                              },
                                              fontSize: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 12,
                                              },
                                            }
                                          ),
                                          dimensions.width
                                        )}
                                      >
                                        {
                                          'All access to desktop functionality\nIncome data entry\nExpense entry\nIncome & Expense Overview\nDesktop dashboard\nWhat If scenario creation'
                                        }
                                      </Text>
                                      {/* Text 2 */}
                                      <>
                                        {!(
                                          listData?.name === 'Basic Plan' ||
                                          listData?.name === 'Pro Plan'
                                        ) ? null : (
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'Inter_400Regular',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Plus mobile dashboard'}
                                          </Text>
                                        )}
                                      </>
                                      {/* Text 3 */}
                                      <>
                                        {!(
                                          listData?.name === 'Pro Plan'
                                        ) ? null : (
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'Inter_400Regular',
                                                  },
                                                  fontSize: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 12,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {
                                              'Shopify sales history integration'
                                            }
                                          </Text>
                                        )}
                                      </>
                                      {/* Space */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value:
                                                listData?.title ===
                                                '5-Day Free Trial'
                                                  ? 35
                                                  : listData?.title ===
                                                    'Basic Plan'
                                                  ? 15
                                                  : 0,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      />
                                    </View>
                                    {/* Button View */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          alignSelf: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'center',
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      <Pressable
                                        onPress={() => {
                                          try {
                                            setSelectedPackage(listData);
                                            if (listData?.demo_prices) {
                                              setVisibleSelectDemo(true);
                                            } else {
                                              setVisibleSelect(true);
                                            }
                                          } catch (err) {
                                            console.error(err);
                                          }
                                        }}
                                        disabled={
                                          Constants['USER_DETAILS']
                                            ?.subscription_plans_id ===
                                            listData?.id &&
                                          !checkExpires(
                                            Constants['USER_DETAILS']
                                              ?.plan_expires_at
                                          )
                                        }
                                      >
                                        {/* Button */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              alignItems: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 'center',
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'center',
                                                },
                                              ],
                                              alignSelf: {
                                                minWidth: Breakpoints.Desktop,
                                                value: 'center',
                                              },
                                              backgroundColor: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value:
                                                    palettes.App[
                                                      'App Blue Light'
                                                    ],
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value:
                                                    palettes.App[
                                                      'App Blue Light'
                                                    ],
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value:
                                                    Constants['USER_DETAILS']
                                                      ?.subscription_plans_id ===
                                                      listData?.id &&
                                                    !checkExpires(
                                                      Constants['USER_DETAILS']
                                                        ?.plan_expires_at
                                                    )
                                                      ? palettes.Brand[
                                                          'App Green'
                                                        ]
                                                      : palettes.App[
                                                          'App Blue Light'
                                                        ],
                                                },
                                              ],
                                              borderColor: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value:
                                                    palettes.Brand[
                                                      'App Blue Dark'
                                                    ],
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value:
                                                    palettes.Brand[
                                                      'App Blue Dark'
                                                    ],
                                                },
                                              ],
                                              borderRadius: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 16,
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 16,
                                                },
                                              ],
                                              borderWidth: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 1,
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                              ],
                                              justifyContent: [
                                                {
                                                  minWidth: Breakpoints.Desktop,
                                                  value: 'center',
                                                },
                                                {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'center',
                                                },
                                              ],
                                              paddingLeft: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 40,
                                              },
                                              paddingRight: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 40,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Text'
                                                ].style,
                                                {
                                                  fontFamily: {
                                                    minWidth:
                                                      Breakpoints.Desktop,
                                                    value: 'Inter_400Regular',
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {Constants['USER_DETAILS']
                                              ?.subscription_plans_id ===
                                            listData?.id
                                              ? 'Active Plan'
                                              : 'Select'}
                                          </Text>
                                        </View>
                                      </Pressable>
                                    </View>
                                  </View>
                                </View>
                                <>
                                  {!(listData?.name === 'Pro Plan') ? null : (
                                    <BlurView
                                      intensity={50}
                                      tint={'default'}
                                      {...GlobalStyles.BlurViewStyles(theme)[
                                        'Blur View'
                                      ].props}
                                      intensity={StyleSheet.getWidthValue(
                                        [
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: 10,
                                          },
                                        ],
                                        dimensions.width
                                      )}
                                      style={StyleSheet.applyWidth(
                                        StyleSheet.compose(
                                          GlobalStyles.BlurViewStyles(theme)[
                                            'Blur View'
                                          ].style,
                                          {
                                            alignItems: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'flex-end',
                                            },
                                            borderRadius: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 12,
                                            },
                                            bottom: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            left: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            overflow: {
                                              minWidth: Breakpoints.Desktop,
                                              value: 'hidden',
                                            },
                                            paddingTop: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 50,
                                            },
                                            position: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'absolute',
                                            },
                                            right: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            top: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            zIndex: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 10,
                                            },
                                          }
                                        ),
                                        dimensions.width
                                      )}
                                      tint={StyleSheet.getWidthValue(
                                        [
                                          {
                                            minWidth: Breakpoints.Desktop,
                                            value: 'default',
                                          },
                                          {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'light',
                                          },
                                        ],
                                        dimensions.width
                                      )}
                                    >
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Text'
                                        ].props}
                                        style={[
                                          StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.TextStyles(theme)[
                                                'Text'
                                              ].style,
                                              {
                                                color: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value:
                                                    palettes.Brand['App Red'],
                                                },
                                                fontFamily: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'OpenSans_700Bold',
                                                },
                                                fontSize: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 20,
                                                },
                                                textTransform: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'capitalize',
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          ),
                                          { transform: 'rotate(45deg)' },
                                        ]}
                                        contentContainerStyle={StyleSheet.applyWidth(
                                          GlobalStyles.TextStyles(theme)['Text']
                                            .style,
                                          dimensions.width
                                        )}
                                      >
                                        {'Coming Soon'}
                                      </Text>
                                    </BlurView>
                                  )}
                                </>
                              </View>
                            </>
                          );
                        }}
                        showsHorizontalScrollIndicator={true}
                        showsVerticalScrollIndicator={true}
                        snapToAlignment={'start'}
                        horizontal={true}
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: {
                              minWidth: Breakpoints.Desktop,
                              value: 'center',
                            },
                            alignSelf: {
                              minWidth: Breakpoints.Laptop,
                              value: 'center',
                            },
                            gap: [
                              { minWidth: Breakpoints.Laptop, value: 10 },
                              { minWidth: Breakpoints.Desktop, value: 20 },
                              { minWidth: Breakpoints.BigScreen, value: 40 },
                            ],
                          },
                          dimensions.width
                        )}
                      />
                    );
                  }}
                </DefaultApi.FetchSubscriptionPlansGET>
              </View>
            </View>
            {/* Back to account */}
            <>
              {!(
                (props.route?.params?.screen_from ??
                  defaultProps.screen_from) === 'account'
              ) ? null : (
                <Link
                  accessible={true}
                  onPress={() => {
                    try {
                      navigation.navigate('AccountScreen');
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  selectable={false}
                  {...GlobalStyles.LinkStyles(theme)['Cancel Link'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.LinkStyles(theme)['Cancel Link'].style,
                      {
                        alignSelf: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        paddingBottom: {
                          minWidth: Breakpoints.Laptop,
                          value: 20,
                        },
                        paddingTop: { minWidth: Breakpoints.Laptop, value: 20 },
                      }
                    ),
                    dimensions.width
                  )}
                  title={'Back to Account'}
                />
              )}
            </>
            {/* Back to login */}
            <>
              {!(
                (props.route?.params?.screen_from ??
                  defaultProps.screen_from) !== 'account'
              ) ? null : (
                <Link
                  accessible={true}
                  onPress={() => {
                    try {
                      navigation.navigate('LoginScreen');
                      setGlobalVariableValue({
                        key: 'AUTH_TOKEN',
                        value: '',
                      });
                      resetGlobals(Variables, setGlobalVariableValue);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  selectable={false}
                  {...GlobalStyles.LinkStyles(theme)['Cancel Link'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.LinkStyles(theme)['Cancel Link'].style,
                      {
                        alignSelf: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        paddingBottom: {
                          minWidth: Breakpoints.Laptop,
                          value: 20,
                        },
                        paddingTop: { minWidth: Breakpoints.Laptop, value: 20 },
                      }
                    ),
                    dimensions.width
                  )}
                  title={'Back to Login'}
                />
              )}
            </>
            <Modal
              animationType={'none'}
              supportedOrientations={['portrait', 'landscape']}
              transparent={false}
              transparent={StyleSheet.getWidthValue(
                [{ minWidth: Breakpoints.Laptop, value: true }],
                dimensions.width
              )}
              visible={visibleSelect}
            >
              <BlurView
                intensity={50}
                tint={'default'}
                {...GlobalStyles.BlurViewStyles(theme)['Blur View'].props}
                intensity={StyleSheet.getWidthValue(
                  [{ minWidth: Breakpoints.Laptop, value: 20 }],
                  dimensions.width
                )}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.BlurViewStyles(theme)['Blur View'].style,
                    {
                      alignItems: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      flex: { minWidth: Breakpoints.Laptop, value: 1 },
                      justifyContent: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                    }
                  ),
                  dimensions.width
                )}
              >
                <Surface
                  {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
                  elevation={3}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.Brand.White,
                        },
                        borderRadius: {
                          minWidth: Breakpoints.Laptop,
                          value: 10,
                        },
                        height: { minWidth: Breakpoints.Laptop, value: 300 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'space-between',
                        },
                        padding: { minWidth: Breakpoints.Laptop, value: 20 },
                        width: {
                          minWidth: Breakpoints.Laptop,
                          value: dimensions.width * (60 / 100),
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'flex-end',
                        },
                        width: { minWidth: Breakpoints.Laptop, value: '100%' },
                      },
                      dimensions.width
                    )}
                  >
                    <IconButton
                      onPress={() => {
                        try {
                          setVisibleSelect(false);
                          setSelectedPackage('');
                          setErrorMessage('');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      size={32}
                      color={StyleSheet.getWidthValue(
                        [
                          {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand['App Red'],
                          },
                        ],
                        dimensions.width
                      )}
                      icon={'AntDesign/closecircle'}
                      style={StyleSheet.applyWidth(
                        { right: { minWidth: Breakpoints.Laptop, value: 0 } },
                        dimensions.width
                      )}
                    />
                  </View>
                  {/* View 2 */}
                  <View>
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            fontFamily: {
                              minWidth: Breakpoints.Laptop,
                              value: 'OpenSans_400Regular',
                            },
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 18,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Are you sure?'}
                    </Text>
                  </View>

                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        {
                          color: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand['App Red'],
                          },
                          textAlign: {
                            minWidth: Breakpoints.Laptop,
                            value: 'center',
                          },
                        }
                      ),
                      dimensions.width
                    )}
                  >
                    {errorMessage}
                  </Text>
                  <Button
                    accessible={true}
                    iconPosition={'left'}
                    onPress={() => {
                      const handler = async () => {
                        try {
                          setIsLoading(true);
                          const apiRes = (
                            await stripeSessionPOST.mutateAsync({
                              amount: convertInt(selectedPackage?.cost),
                              id: selectedPackage?.id,
                              price: selectedPackage?.price_id,
                            })
                          )?.json;
                          if (selectedPackage?.id === 1) {
                            setVisibleSelect(false);
                            navigation.navigate('GetStartedScreen', {
                              navigated: 'signup',
                            });
                          } else {
                            if (apiRes?.url) {
                              /* hidden 'Open Browser' action */
                              Linking.openURL(`${apiRes?.url}`);
                              setVisibleSelect(false);
                            } else {
                              setErrorMessage(apiRes?.message);
                            }
                          }

                          setIsLoading(false);
                        } catch (err) {
                          console.error(err);
                        }
                      };
                      handler();
                    }}
                    {...GlobalStyles.ButtonStyles(theme)['Button'].props}
                    loading={isLoading}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.ButtonStyles(theme)['Button'].style,
                        {
                          backgroundColor: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand['App Green'],
                          },
                          color: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand.Black,
                          },
                          width: { minWidth: Breakpoints.Laptop, value: 200 },
                        }
                      ),
                      dimensions.width
                    )}
                    title={`${
                      selectedPackage?.id === 1
                        ? 'Start Free Trial'
                        : 'Subscribe'
                    }`}
                  />
                </Surface>
              </BlurView>
            </Modal>
            {/* Modal 2 */}
            <Modal
              animationType={'none'}
              supportedOrientations={['portrait', 'landscape']}
              transparent={false}
              transparent={StyleSheet.getWidthValue(
                [{ minWidth: Breakpoints.Laptop, value: true }],
                dimensions.width
              )}
              visible={visibleSelectDemo}
            >
              <BlurView
                intensity={50}
                tint={'default'}
                {...GlobalStyles.BlurViewStyles(theme)['Blur View'].props}
                intensity={StyleSheet.getWidthValue(
                  [{ minWidth: Breakpoints.Laptop, value: 20 }],
                  dimensions.width
                )}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.BlurViewStyles(theme)['Blur View'].style,
                    {
                      alignItems: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      flex: { minWidth: Breakpoints.Laptop, value: 1 },
                      justifyContent: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                    }
                  ),
                  dimensions.width
                )}
              >
                <Surface
                  {...GlobalStyles.SurfaceStyles(theme)['Surface'].props}
                  elevation={3}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.SurfaceStyles(theme)['Surface'].style,
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.Brand.White,
                        },
                        borderRadius: {
                          minWidth: Breakpoints.Laptop,
                          value: 10,
                        },
                        height: { minWidth: Breakpoints.Laptop, value: 300 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'space-between',
                        },
                        padding: { minWidth: Breakpoints.Laptop, value: 20 },
                        width: {
                          minWidth: Breakpoints.Laptop,
                          value: dimensions.width * (60 / 100),
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'flex-end',
                        },
                        width: { minWidth: Breakpoints.Laptop, value: '100%' },
                      },
                      dimensions.width
                    )}
                  >
                    <IconButton
                      onPress={() => {
                        try {
                          setVisibleSelect(false);
                          setSelectedPackage('');
                          setErrorMessage('');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      size={32}
                      color={StyleSheet.getWidthValue(
                        [
                          {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand['App Red'],
                          },
                        ],
                        dimensions.width
                      )}
                      icon={'AntDesign/closecircle'}
                      style={StyleSheet.applyWidth(
                        { right: { minWidth: Breakpoints.Laptop, value: 0 } },
                        dimensions.width
                      )}
                    />
                  </View>
                  {/* View 2 */}
                  <View>
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            fontFamily: {
                              minWidth: Breakpoints.Laptop,
                              value: 'OpenSans_400Regular',
                            },
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 18,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Are you sure?'}
                    </Text>
                  </View>

                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        {
                          color: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand['App Red'],
                          },
                          textAlign: {
                            minWidth: Breakpoints.Laptop,
                            value: 'center',
                          },
                        }
                      ),
                      dimensions.width
                    )}
                  >
                    {errorMessage}
                  </Text>
                  <Button
                    accessible={true}
                    iconPosition={'left'}
                    onPress={() => {
                      const handler = async () => {
                        try {
                          setIsLoading(true);
                          const apiRes = (
                            await defaultActivateDemoSubscriptionPOST.mutateAsync(
                              { id: selectedPackage?.id }
                            )
                          )?.json;
                          if (!apiRes?.message) {
                            setVisibleSelectDemo(false);
                            navigation.navigate('GetStartedScreen', {
                              navigated: 'signup',
                            });
                          } else {
                            setErrorMessage(apiRes?.message);
                          }

                          setIsLoading(false);
                        } catch (err) {
                          console.error(err);
                        }
                      };
                      handler();
                    }}
                    {...GlobalStyles.ButtonStyles(theme)['Button'].props}
                    loading={isLoading}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.ButtonStyles(theme)['Button'].style,
                        {
                          backgroundColor: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand['App Green'],
                          },
                          color: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand.Black,
                          },
                          width: { minWidth: Breakpoints.Laptop, value: 200 },
                        }
                      ),
                      dimensions.width
                    )}
                    title={`${
                      selectedPackage?.id === 1
                        ? 'Start Free Trial'
                        : 'Subscribe'
                    }`}
                  />
                </Surface>
              </BlurView>
            </Modal>
          </SimpleStyleScrollView>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(PaymentPlanSelectionScreen);
